import { Autocomplete } from "@mui/material";

const StrassenAutocomplete = ({
  id,
  onChange,
  value,
  options,
  noOptionsText,
  renderInput,
  getOptionLabel,
  autoFocus,
  key,
  defaultValue,
  isOptionEqualToValue,
}) => {
  const handleFilterOptions = (options, state) => {
    var tmpStraße = state.inputValue
      .toUpperCase()
      .replace("ß", "SS")
      .replace("Ä", "AE")
      .replace("Ö", "OE")
      .replace("Ü", "UE")
      .replace(/[^a-zA-Z0-9]/g, "")
      .replace("STRASSE", "STR")
      .replace("STRASS", "STR")
      .replace("STRAS", "STR")
      .replace("STRA", "STR");
    return options
      .filter((option) => option.suchstrasse?.includes(tmpStraße))
      .sort(
        (a, b) =>
          a.suchstrasse.indexOf(tmpStraße) - b.suchstrasse.indexOf(tmpStraße)
      );
  };

  return (
    <Autocomplete
      id={id}
      key={key}
      onChange={onChange}
      value={value}
      options={options}
      noOptionsText={noOptionsText}
      filterOptions={handleFilterOptions}
      getOptionLabel={getOptionLabel}
      renderInput={renderInput}
      autoFocus={autoFocus}
      defaultValue={defaultValue}
      isOptionEqualToValue={isOptionEqualToValue}
    />
  );
};

export default StrassenAutocomplete;
